/**
 * W66.W6 — ICP fit section: narrative paragraph + qualifying-factor chips.
 */

import React from "react";

interface IcpFitBlockProps {
  planData: Record<string, any>;
}

export default function IcpFitBlock({ planData }: IcpFitBlockProps) {
  const icp = planData.icp_fit ?? {};
  const narrative = icp.narrative ?? "";
  const factors: string[] = icp.qualifying_factors ?? [];

  if (!narrative && factors.length === 0) return null;

  return (
    <section style={{ marginBottom: 28 }}>
      <h2
        style={{
          fontSize: 12,
          fontWeight: 700,
          color: "#374151",
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          margin: "0 0 10px",
          borderBottom: "1px solid #E5E7EB",
          paddingBottom: 6,
        }}
      >
        ICP Fit
      </h2>

      {narrative && (
        <p style={{ fontSize: 14, color: "#374151", lineHeight: 1.6, margin: "0 0 12px" }}>
          {narrative}
        </p>
      )}

      {factors.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
          {factors.map((f, i) => (
            <span
              key={i}
              style={{
                background: "#F0FDF4",
                border: "1px solid #BBF7D0",
                color: "#166534",
                borderRadius: 20,
                padding: "3px 10px",
                fontSize: 12,
                fontWeight: 500,
              }}
            >
              {f}
            </span>
          ))}
        </div>
      )}
    </section>
  );
}
